// extracted by mini-css-extract-plugin
module.exports = {"container":"_38qyj5G8bViKYMwh28Ebbe","groupsList":"_3E5LsM4GRz4sNYi16W0W46"};